import styled from 'styled-components';
import { colorsV2 } from '../../../../../figma/colors-v2';

export const VocabFlowElementMain = styled.div`
  display: inline;
  transition: all 0.3s ease;
  cursor: pointer;
  color: ${colorsV2.accent100};
  text-decoration-line: underline;

  .icon-wrapper {
    display: inline-block;
    color: ${colorsV2.red100};
    line-height: 0;
    font-size: 16px;
    position: relative;
    bottom: 2px;
  }

  &.is-error {
    color: ${colorsV2.red100};
    font-weight: bold;
  }

  &.with-hover {
    &:hover,
    ::selection {
      background-color: ${colorsV2.primary20};
    }
  }
`;
